<template>
  <a-modal
    title="绑定业务平台"
    :visible="visible"
    :confirmLoading="confirmLoading"

    okText="提交"
    cancelText="取消"
    @ok="handlerSubmit"
    @cancel="() => $emit('close')"

    :afterClose="afterHideEditModal"
  >
    <a-form-model
      ref="shopForm"
      :model="shopForm"
      :rules="shopFormRules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="业务平台" prop="appId">
        <a-select v-model="shopForm.appId" placeholder="请选择">
          <a-select-option v-for="(item,index) in appList " :key="index" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="是否订阅" prop="isSubscribe">
        <a-radio-group v-model="shopForm.isSubscribe">
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
/*
* 	门店地址		false
	门店扩展参数1		false
* 	*/
import { AppIndex } from '@/apis/app'

const shopForm = {
  appId: undefined,
  isSubscribe: false,
}
const shopFormRules = {
  appId: [{ required: true, message: '请选择业务平台！' }],
  isSubscribe: [{ required: true, message: '请选择是否订阅！' }],
}


export default {
  name: 'BindAppModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      shopForm,
      shopFormRules,
      adcOptions:[],
      templateList:[],
      appList:[],
      uploading: false,
      confirmLoading:false,
    }
  },
  computed: {},
  watch: {
    visible: function (val){
      //
      if (val && this.obj){
        this.$nextTick(() => {
        })
      }
    }
  },

  created() {
    this.getAppList()
  },
  methods: {
    getAppList(){
      AppIndex({page: 1, perPage: 100}).then(res=>{
        if (res.code === 0){
          this.appList = res.collection
        }
      })
    },
    // 提交模态框数据
    handlerSubmit() {
      this.$refs.shopForm.validate(async valid => {
        if (valid) {
          this.$emit('submit', this.shopForm)
          this.confirmLoading = true
        }
      })
    },

    // 编辑终端标识组模态框关闭后，重置相关数据
    afterHideEditModal() {
      this.$refs.shopForm.resetFields()
      this.shopForm = shopForm
      this.confirmLoading = false
    },
  }
}
</script>

<style lang="less" scoped>
  ::v-deep .ant-modal{
    width: 700px !important
  }
  ::v-deep .ant-form-item{
    margin-bottom: 12px;
  }
  .ant-checkbox-group>.ant-checkbox-wrapper:first-child{
    margin-left: 8px !important;
  }
</style>
